import React, { useEffect } from 'react';
import TeamMemberCard from './TeamMemberCard'; 

import baryPhoto from '../team/bary.png';
import maraPhoto from '../team/mistrmara.png';
import jiricech2059Photo from '../team/jiricech2059.png';
import squizerPhoto from '../team/squizer.png';

const teamMembersData = [
  {
    initials: 'BA', // Update if desired
    name: 'Bary',
    role: 'Founder & Chief Architect', // More professional role
    description: 'Bary leads DEVCORE\'s strategic vision, applying extensive FiveM development expertise to innovate core systems and solutions.',
    github: 'https://github.com/DevCore01', // Replace with actual links
    discord: 'https://discord.com/users/573948312042864655',
    imageUrl: baryPhoto,
  },
  {
    initials: 'MM', // Update if desired
    name: 'Mistr Mara',
    role: 'Operations & Community Lead', // More professional role
    description: 'Mistr Mara manages operational workflows, ensures project efficiency, and cultivates a vibrant, user-friendly community.',
    github: 'https://github.com/MaraHraje', // Replace with actual links
    discord: 'https://discord.com/users/668123961921503248',
    imageUrl: maraPhoto,
  },
  {
    initials: 'J2', // Update if desired
    name: 'Jiricech2059',
    role: 'Senior Software Engineer', // More professional role
    description: 'Jiricech2059 develops and optimizes high-performance scripts, ensuring seamless integration and scalability for all DEVCORE resources.',
    github: 'https://github.com/Jiri2059', // Replace with actual links
    discord: 'https://discord.com/users/817517695566086206',
    imageUrl: jiricech2059Photo,
  },
  {
    initials: 'SQ', // Initials for Squizer
    name: 'Squizer',
    role: 'Community Coordinator',
    description: 'Squizer enhances the DEVCORE community by actively engaging members, providing support, and gathering feedback for improvement.',
    github: 'https://github.com/czsquizer',
    discord: 'https://discord.com/users/428454091006672912',
    imageUrl: squizerPhoto,
  },
];

const HomePage = () => {
  useEffect(() => {
    // Add animation to elements when they come into view
    const observerOptions = {
        threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-fadeIn');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    document.querySelectorAll('.glass-card, .team-card, .feature-card').forEach(card => {
        card.classList.add('opacity-0', 'transition-opacity', 'duration-500');
        observer.observe(card);
    });

    // Add fade-in animation when elements come into view
    const fadeInTimeout = setTimeout(() => {
        document.querySelectorAll('.glass-card, .team-card, .feature-card').forEach(card => {
            card.classList.remove('opacity-0');
        });
    }, 100);

    return () => clearTimeout(fadeInTimeout); // Cleanup timeout on unmount
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section id="home" className="pt-32 pb-20 px-6 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full opacity-20">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-devcore.primary filter blur-3xl opacity-30 animate-pulse-slow"></div>
          <div className="absolute top-2/3 right-1/4 w-80 h-80 rounded-full bg-blue-400 filter blur-3xl opacity-20 animate-pulse-slow"></div>
        </div>

        <div className="max-w-7xl mx-auto relative z-10">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-12 md:mb-0">
              <h1 className="text-4xl md:text-6xl font-bold mb-6">
                <span className="gradient-text">Innovative</span> FiveM Scripts
              </h1>
              <p className="text-lg text-gray-300 mb-8">
                We create cutting-edge, high-performance scripts that push the boundaries of what's possible in FiveM roleplay servers.
              </p>
              <div className="flex flex-wrap gap-4">
                {/* <a href="/scripts" className="px-6 py-3 bg-devcore.primary rounded-md text-white hover:bg-blue-600 transition flex items-center space-x-2"> */}
                <a href="/scripts" className="px-6 py-3 bg-[#316dae] rounded-md text-white hover:bg-blue-600 transition flex items-center space-x-2">
                  <span>Explore Scripts</span>
                  <i className="fas fa-arrow-right"></i>
                </a>
                <button className="px-6 py-3 bg-gray-700 rounded-md text-white hover:bg-gray-600 transition flex items-center space-x-2">
                  <span>Go to Panel</span>
                  <i className="fas fa-th-large"></i>
                </button>
              </div>
            </div>

            <div className="md:w-1/2 flex justify-center">
              <div className="relative w-full max-w-md">
                <div className="absolute -top-10 -left-10 w-64 h-64 bg-devcore.primary rounded-full filter blur-xl opacity-20 animate-float"></div>
                <div className="absolute bottom-0 right-0 w-56 h-56 bg-blue-400 rounded-full filter blur-xl opacity-20 animate-float-reverse"></div>

                <div className="glass-card p-6 rounded-2xl relative">
                  <div className="bg-devcore.dark p-4 rounded-lg mb-4">
                    <div className="flex space-x-2 mb-3">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                    <div className="font-mono text-sm text-gray-300">
                    <p className="text-devcore.primary">// DEVCORE Script Example</p>
                    <p className="my-2">RegisterCommand('devcore', function() {'{'}</p>
                    <p className="ml-4">TriggerEvent('devcore:showUI', {'{'}</p>
                    <p className="ml-8">title: "Innovation",</p>
                    <p className="ml-8">features: ["Modern", "Optimized", "Unique"]</p>
                    <p className="ml-4">{'}'});</p>
                    <p>{'}'}, false);</p>
                    </div>
                  </div>
                  <p className="text-gray-300 text-sm">Experience the power of our optimized, feature-rich scripts designed for the most demanding FiveM servers.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
    <section id="team" className="py-20 px-6 gradient-bg">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Meet <span className="gradient-text">The Team</span></h2>
          <p className="text-gray-300 max-w-2xl mx-auto">The creative minds behind DEVCORE's innovative scripts</p>
        </div>

        {/* --- CHANGE MADE HERE --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembersData.map((member, index) => (
            <TeamMemberCard
              key={index}
              initials={member.initials}
              name={member.name}
              role={member.role}
              description={member.description}
              github={member.github}
              discord={member.discord}
              twitter={member.twitter}
              imageUrl={member.imageUrl}
            />
          ))}
        </div>
        {/* ------------------------ */}
      </div>
    </section>

      {/* Contact CTA */}
      <section className="py-16 px-6 bg-devcore.dark">
        <div className="max-w-4xl mx-auto glass-card rounded-xl p-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Have Questions? <span className="gradient-text">Get In Touch</span></h2>
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto">Our team is here to help with any questions about our scripts, implementation, or custom development.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="https://discord.gg/zcG9KQj3sa" className="px-6 py-3 bg-devcore.primary rounded-md text-white hover:bg-blue-600 transition flex items-center space-x-2">
              <i className="fab fa-discord"></i>
              <span>Join Our Discord</span>
            </a>
            <a href="mailto:" className="px-6 py-3 glass-card rounded-md text-white hover:bg-white hover:bg-opacity-10 transition flex items-center space-x-2">
              <i className="fas fa-envelope"></i>
              <span>Email Us</span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;